import { SnowplowService } from 'wanderu-service-analytics';

function trackFID({ delay, entry = {} }) {
    const {
        duration,
        entryType,
        name,
        processingEnd,
        processingStart,
        startTime,
        target,
    } = entry;
    const className = target?.className;

    SnowplowService.fireStructuredEvent({
        category: 'app_performance',
        action: 'loaded',
        label: 'first_input_delay',
        property: {
            delay,
            entry: {
                duration,
                entryType,
                name,
                processingEnd,
                processingStart,
                startTime,
            },
            target: className,
        },
    });
}

export default {
    trackFID,
};
